import React, {useLayoutEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Input,
    Typography
} from "@material-tailwind/react";
import axios from "axios";
import LotSummary from "./lot_summary";

// Motivo 23 - PROMESA DE VENTA: registro documental de la promesa (datos del R.P.P.)
// sin cambio de propietario ni efecto fiscal.
const SalePromise = ({lot, movement}) => {
    const [lotNotes, setLotNotes] = useState("");
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [loaderActive, setLoaderActive] = useState(false);
    const [error, setError] = useState(null);
    const [registry, setRegistry] = useState({
        inscription: "",
        book: "",
        folio: "",
    });

    useLayoutEffect(() => {
        setRegistry({
            inscription: lot.inscription,
            book: lot.book,
            folio: lot.folio,
        });
        setLotNotes(lot.notes);
    }, [lot]);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    const handleReset = () => {
        window.location.replace('movements');
    };

    const handleSubmit = async () => {
        try {
            setLoaderActive(true);
            const response = await axios.put(`lots/${lot.parcel_code}.json`, {
                lot: {
                    inscription: registry.inscription,
                    book: registry.book,
                    folio: registry.folio,
                    notes: lotNotes,
                    reason_type_id: movement.id,
                },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                window.open(url, '_blank');
                setLoaderActive(false);
            } else {
                setError('Error al registrar la promesa de venta. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Error al guardar. Verifica los datos.');
            setLoaderActive(false);
        }
    };

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información del predio
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        <LotSummary lot={lot}/>
                    </div>
                </div>
            </div>
            <div className="flex-auto py-10 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Promesa de venta
                </h6>
                <Card className='w-full border border-blue-gray-100 rounded-b-lg rounded-t-none' shadow={false}>
                    <CardBody className='p-4'>
                        <div className='py-2'>
                            <Typography
                                variant="small"
                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                            >
                                Datos del R.P.P.
                            </Typography>
                            <div className='flex flex-row gap-4 w-full text-center'>
                                <Input value={registry.inscription || ""}
                                       onChange={(e) => setRegistry((prev) => ({
                                           ...prev,
                                           inscription: e.target.value,
                                       }))}
                                       label={'Inscripción'}
                                       containerProps={{
                                           className: '!min-w-0'
                                       }}
                                />
                                <Input value={registry.book || ""}
                                       onChange={(e) => setRegistry((prev) => ({
                                           ...prev,
                                           book: e.target.value,
                                       }))}
                                       label={'Libro'}
                                       containerProps={{
                                           className: '!min-w-0'
                                       }}
                                />
                                <Input value={registry.folio || ""}
                                       onChange={(e) => setRegistry((prev) => ({
                                           ...prev,
                                           folio: e.target.value,
                                       }))}
                                       label={'Folio'}
                                       containerProps={{
                                           className: '!min-w-0'
                                       }}
                                />
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                            NOTAS DE MOVIMIENTOS DEL PREDIO
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                    >
                                        Notas
                                    </Typography>
                                    <textarea
                                        type="text"
                                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={lotNotes || ""}
                                        onChange={(e) => setLotNotes(e.target.value)}
                                        rows="6"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <Button
                            className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                            onClick={() => handleSubmit()}
                            disabled={loaderActive}
                        >
                            GUARDAR
                        </Button>
                        {
                            error && <p style={{color: "red"}}>{error}</p>
                        }
                    </CardBody>
                </Card>
            </div>
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se registró la promesa de venta del predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                        disabled={loaderActive}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default SalePromise;
